import prayers from './pray.json';
import {useParams} from 'react-router-dom';
import {IPrayerCategory} from './PrayerCategory';
import SubPrayer from './SubPrayer';
import PrayerContent from './PrayerContent';

export default function Prayer() {
	const {id, subId, endId} = useParams();
	
	// @ts-ignore
	let subPrayer: IPrayerCategory = prayers[Number(id)];
	if (subPrayer && subId && subPrayer.children) {
		subPrayer = subPrayer.children[Number(subId)];
	}
	if (subPrayer && endId && subPrayer.children) {
		subPrayer = subPrayer.children[Number(endId)];
	}
	
	if (subPrayer) {
		if (subPrayer.children) {
			return <SubPrayer prayer={subPrayer} url={`/prayer/${id}${subId ? `/${subId}` : ''}/`}/>;
		} else {
			return <PrayerContent prayer={subPrayer}/>;
		}
	} else {
		// TODO show 404 page
		return <>Not found</>;
	}
}
